import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    opus: {
        id: "meta.opus",
    },
    rhythm: {
        id: "meta.rhythm",
    },
    pitch: {
        id: "meta.pitch",
    },
});

export default messages;
